import { apiSlice } from './api-slice';
import {
  CompleteUploadData,
  Directory,
  InitiatedUpload,
  InitiatedUploadData,
  ModuleName,
  Response,
  Upload,
} from '../models';

export const uploadsApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    initiateUpload: builder.mutation<
      Response<InitiatedUpload>,
      { data: InitiatedUploadData; moduleName: ModuleName }
    >({
      query: ({ data, moduleName }) => {
        return {
          url: `company/${moduleName.toLowerCase()}/v2/initiateUpload`,
          method: 'POST',
          body: data,
        };
      },
    }),
    upload: builder.mutation<Response<Upload>, FormData>({
      query: data => {
        const moduleName = data.get('moduleName') as ModuleName;
        data.delete('moduleName');

        return {
          url: `company/${moduleName.toLowerCase()}/v2/upload`,
          method: 'POST',
          body: data,
        };
      },
    }),
    completeUpload: builder.mutation<
      Response<Directory>,
      { data: CompleteUploadData; moduleName: ModuleName }
    >({
      query: ({ data, moduleName }) => {
        return {
          url: `company/${moduleName.toLowerCase()}/v2/completeUpload`,
          method: 'POST',
          body: data,
        };
      },
      // invalidatesTags: (_, __, { moduleName, data }) => [
      // { type: moduleName, id: data.attachedId },
      // ],
    }),
  }),
});

export const {
  useInitiateUploadMutation,
  useUploadMutation,
  useCompleteUploadMutation,
} = uploadsApiSlice;
